import { Component, OnInit } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { FeatureService } from 'src/app/private/services/feature.service';
import { ChipModule } from 'primeng/chip';
import { AddFeatureComponent } from "../../components/features/add-feature/add-feature.component";
import { DeleteFeatureComponent } from "../../components/features/delete-feature/delete-feature.component";

@Component({
    selector: 'app-features',
    imports: [ToolBarComponent, SharedModule, ChipModule, AddFeatureComponent, DeleteFeatureComponent],
    templateUrl: './features.component.html',
    styleUrl: './features.component.scss'
})
export class FeaturesComponent implements OnInit {

    selectedProducts: any[] = [];

    totalRecords: number = 0;
    rows: number = 50;
    pageSizeOptions = [10, 20, 50];
    loading: boolean = false;
    featuresData: any[] = [];

    showEditFeature: boolean = false;
    showDeleteFeature: boolean = false;
    featureDataToEdit: any = null;

    displayAddModal: boolean = false;

    constructor(
        private api: FeatureService
    ) { }

    featureActionItems: any[] = [
        {
            label: 'Options',
            items: [
                {
                    label: 'Edit Feature',
                    icon: 'pi pi-fw pi-pencil',
                    command: () => {
                        this.displayAddModal = true;
                    }
                },
                {
                    label: 'Delete Feature',
                    icon: 'pi pi-fw pi-trash',
                    styleClass: 'delete-menu-item',
                    command: () => {
                        this.showDeleteFeature = true;
                    }
                }
            ]
        }
    ]

    unitTypeOptions = [
        { label: 'Users', value: 'users' },
        { label: 'GB (Storage)', value: 'GB' },
        { label: 'Campaigns', value: 'campaigns' },
        { label: 'Templates', value: 'templates' },
        { label: 'Leads', value: 'leads' },
        { label: 'Contacts', value: 'contacts' },
        { label: 'Deals', value: 'deals' },
        { label: 'Invoices', value: 'invoices' },
        { label: 'Quotes', value: 'quotes' },
        { label: 'Contact Groups', value: 'contact_groups' },
        { label: 'Group Contacts', value: 'group_contacts' },
        { label: 'Email Sends', value: 'email_sends' },
        { label: 'SMS Sends', value: 'sms_sends' },
        { label: 'WhatsApp Messages', value: 'whatsapp_messages' },
        { label: 'Tasks', value: 'tasks' },
        { label: 'Projects', value: 'projects' },
        { label: 'Pipelines', value: 'pipelines' },
        { label: 'Custom Fields', value: 'custom_fields' },
        { label: 'Workflows', value: 'workflows' },
        { label: 'Automations', value: 'automations' },
        { label: 'Reports', value: 'reports' },
        { label: 'Dashboards', value: 'dashboards' },
        { label: 'API Calls', value: 'api_calls' },
        { label: 'Integrations', value: 'integrations' },
        { label: 'Team Members', value: 'team_members' },
        { label: 'Products', value: 'products' },
        { label: 'Services', value: 'services' },
        { label: 'Tickets', value: 'tickets' },
        { label: 'Knowledge Base Articles', value: 'kb_articles' },
        { label: 'Email Accounts', value: 'email_accounts' },
        { label: 'Phone Numbers', value: 'phone_numbers' },
        { label: 'Documents', value: 'documents' },
        { label: 'Attachments (MB)', value: 'attachments_mb' },
        { label: 'Meetings', value: 'meetings' },
        { label: 'Appointments', value: 'appointments' },
        { label: 'Notes', value: 'notes' },
        { label: 'Tags', value: 'tags' },
        { label: 'Segments', value: 'segments' },
        { label: 'Landing Pages', value: 'landing_pages' },
        { label: 'Forms', value: 'forms' },
        { label: 'Surveys', value: 'surveys' },
        { label: 'Email Templates', value: 'email_templates' },
        { label: 'SMS Templates', value: 'sms_templates' },
        { label: 'WhatsApp Templates', value: 'whatsapp_templates' },
        { label: 'Broadcast Campaigns', value: 'broadcast_campaigns' },
        { label: 'Drip Campaigns', value: 'drip_campaigns' },
        { label: 'A/B Tests', value: 'ab_tests' },
        { label: 'Web Forms', value: 'web_forms' },
        { label: 'Chatbots', value: 'chatbots' },
        { label: 'Live Chat Sessions', value: 'live_chat_sessions' }
    ];

    formatUnitType(unitType: string): string {
        const option = this.unitTypeOptions.find(opt => opt.value === unitType);
        return option ? option.label : unitType;
    }

    formatCategory(category: string): string {
        if (!category) return 'N/A';
        return category === 'fixed' ? 'Fixed Feature' : category === 'limit' ? 'Limit Feature' : category;
    }

    formatFeatureLevel(level: string): string {
        if (!level) return 'N/A';
        const levels: any = {
            'module': 'Module',
            'module_feature': 'Module Feature',
            'submodule': 'Sub-Module',
            'submodule_feature': 'Sub-Module Feature'
        };
        return levels[level] || level;
    }

    getPermissionLabel(permissionValue: string): string {
        const permissionOptions = [
            { label: 'Create', value: 'create' },
            { label: 'Read/View', value: 'read' },
            { label: 'Update/Edit', value: 'update' },
            { label: 'Delete', value: 'delete' },
            { label: 'Filter', value: 'filter' },
            { label: 'Search', value: 'search' },
            { label: 'Export', value: 'export' },
            { label: 'Import', value: 'import' },
            { label: 'Print', value: 'print' },
            { label: 'Share', value: 'share' },
            { label: 'Duplicate', value: 'duplicate' },
            { label: 'Archive', value: 'archive' },
            { label: 'Restore', value: 'restore' },
            { label: 'Bulk Actions', value: 'bulk_actions' },
            { label: 'Advanced Settings', value: 'advanced_settings' },
            { label: 'Assign/Transfer', value: 'assign' },
            { label: 'Comment/Note', value: 'comment' },
            { label: 'Attach Files', value: 'attach' },
            { label: 'View History', value: 'view_history' },
            { label: 'Approve/Reject', value: 'approve' }
        ];
        const permission = permissionOptions.find(opt => opt.value === permissionValue);
        return permission ? permission.label : permissionValue;
    }

    getPermissionsTooltip(permissions: string[]): string {
        return permissions.slice(3).map(p => this.getPermissionLabel(p)).join(', ');
    }

    // Filter features by category
    getFixedFeatures(): any[] {
        return this.featuresData.filter(f => f.category === 'fixed');
    }

    getLimitFeatures(): any[] {
        return this.featuresData.filter(f => f.category === 'limit');
    }

    // Get modules (top-level features with no parent)
    getModules(): any[] {
        return this.featuresData.filter(f => 
            f.feature_level === 'module' && !f.parent_feature_key
        );
    }

    // Get fixed modules only
    getFixedModules(): any[] {
        return this.featuresData.filter(f => 
            f.category === 'fixed' && 
            f.feature_level === 'module' && 
            !f.parent_feature_key
        );
    }

    // Get orphaned fixed features (features without parents that aren't modules)
    getOrphanedFixedFeatures(): any[] {
        return this.featuresData.filter(f => 
            f.category === 'fixed' && 
            f.feature_level !== 'module' && 
            !f.parent_feature_key
        );
    }

    // Get child features for a given parent
    getChildFeatures(parentKey: string, category: string): any[] {
        return this.featuresData.filter(f => 
            f.parent_feature_key === parentKey && 
            f.category === category
        );
    }

    // Get active features count
    getActiveFeatures(): any[] {
        return this.featuresData.filter(f => f.status === 'Active');
    }

    // Edit feature
    editFeature(feature: any): void {
        this.featureDataToEdit = feature;
        this.displayAddModal = true;
    }

    // Delete feature
    deleteFeature(feature: any): void {
        this.featureDataToEdit = feature;
        this.showDeleteFeature = true;
    }

    loadFeatures(event: any) {
        this.loading = true;

        const page = event.first / event.rows;
        const size = event.rows;

        const body = {
            "page": page,
            "limit": size,
            "where": {},
            "order": [["feature_key", "ASC"]]
        }
        this.api.findAndCountAllFeature(body).subscribe({
            next: (data) => {
                this.featuresData = data?.data || [];
                this.totalRecords = data?.count || 0;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            },
        });
    }

    reloadFeatures() {
       // this.loadAllFeatures();
    }

    loadAllFeatures() {
        console.log("loading all features");
        this.loading = true;
        const body = {
            "page": 0,
            "limit": 1000, // Load all features
            "where": {},
            "order": [["feature_key", "ASC"]]
        }
        this.api.findAndCountAllFeature(body).subscribe({
            next: (data) => {
                console.log("feature data",data);
                this.featuresData = data?.data || [];
                this.totalRecords = data?.count || 0;
                this.loading = false;
            },
            error: () => {
                this.loading = false;
            },
        });
    }

    setFeatureData(feature: any) {
        this.featureDataToEdit = feature;
    }

    openAddModal() {
        this.featureDataToEdit = null;
        this.displayAddModal = true;
    }

    ngOnInit(): void {
        // Load all features without pagination for hierarchical view
        this.loadAllFeatures();
    }
}
